import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { IProviderSource } from '@assess/shared/data-mart';
import { IProviderSearchBody, IProviderSearchResult, processProviderBody } from '@assess/shared/data-mart-search';

import { SearchService } from './search.service';

export interface ITransformedBodyFilters extends Partial<Pick<IProviderSource, 'ActiveInd' | 'Specialty'>> {}

@Injectable({ providedIn: 'root' })
export class ProviderSearchService {
  private readonly resourceType = 'provider';

  constructor(private readonly searchService: SearchService) {}

  search(body: Partial<IProviderSearchBody>): Observable<IProviderSearchResult> {
    return this.searchService.search<IProviderSource>(this.resourceType, processProviderBody(body));
  }
}
